"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Working() {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "56", height: "56", viewBox: "0 0 56 56" },
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 1.778)" },
            react_1.default.createElement("rect", { width: "38", height: "50", x: "7", y: "1", fill: "#F5F5F5", stroke: "#BFBFBF", strokeWidth: "2" }),
            react_1.default.createElement("path", { fill: "#FFF", stroke: "#BFBFBF", strokeWidth: "2", d: "M23,33 L23,39 L13,39 L13,33 L23,33 Z M39,33 L39,39 L29,39 L29,33 L39,33 Z M23,21 L23,27 L13,27 L13,21 L23,21 Z M39,21 L39,27 L29,27 L29,21 L39,21 Z M23,9 L23,15 L13,15 L13,9 L23,9 Z M39,9 L39,15 L29,15 L29,9 L39,9 Z" }),
            react_1.default.createElement("rect", { width: "52", height: "2", y: "50", fill: "#BFBFBF" }))));
}
exports.default = Working;
//# sourceMappingURL=Working.js.map